export * from './Header';
export * from './Center';
export * from './Footer';
export * from './Container';
//# sourceMappingURL=index.js.map